import Axios from "axios";
import { getHeaders } from '../../utills';
import GeneralAction from "../Actions/GeneralAction";
import LocationAction from "../Actions/LocationAction";
import EditChecklistActions from "../Actions/EditChecklistActions";
import Apis from "../Apis";
// import { Alert } from "react-native";
import AlertAction from "../Actions/AlertActions";


class LocationMiddleware {

    static getActiveLocations = (userData) => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    if (userData?.search || userData?.Status || userData?.next_page_url == undefined) {
                        if (userData?.search && userData?.Status && userData?.next_page_url) {
                        }
                        else {
                            dispatch(LocationAction.clearActiveLocations())
                        }
                    }
                    let formdata = new FormData()
                    formdata.append('name', userData?.search);
                    formdata.append('status', userData?.Status);
                    const { data } = await Axios.post(
                        Apis.getActiveLocations(userData?.next_page_url),
                        formdata,
                        {
                            headers: getHeaders()
                        }
                    );
                    if (data?.success) {
                        dispatch(LocationAction.getActiveLocations(data?.data))
                        dispatch(GeneralAction.HideLoading())
                    } else {
                        dispatch(GeneralAction.HideLoading())
                    }
                }
                catch (error) {
                    reject(error)
                    console.log(error.message)
                    dispatch(GeneralAction.HideLoading())
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

                    // alert('Network Error !')
                }
            })
        }
    }


    static getLocationsInstruction = (id) => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.get(
                        Apis.jobDetail + `${id}`,
                        {
                            headers: getHeaders()
                        }
                    );
                    if (data?.success) {
                        dispatch(EditChecklistActions.clearEditCheckList())
                        dispatch(EditChecklistActions.getEditCheckList(data?.data))
                        dispatch(GeneralAction.HideLoading())
                    } else {
                        dispatch(GeneralAction.HideLoading())
                    }
                }
                catch (error) {
                    reject(error)
                    console.log(error.message)
                    dispatch(GeneralAction.HideLoading())
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

                    // alert('Network Error !')
                }
            })
        }
    }


    static updateChecklist = (userData) => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading())
            return new Promise(async (resolve, reject) => {
                try {

                    // console.log("+=++++=+++=+++", userData)
                    let formdata = new FormData()
                    formdata.append('name', userData?.name)
                    formdata.append('id', userData?.id)
                    for (const [i, document] of userData?.AddedItem.entries()) {
                        formdata.append(`items[${i}][name]`, document?.name);
                        formdata.append(`items[${i}][description]`, document?.description);
                        if (document?.id) {
                            formdata.append(`items[${i}][id]`, document?.id)
                        }
                        if (document?.attachment) {
                            formdata.append(`items[${i}][attachment]`, document?.attachment)
                        }
                        // document?.id ? formdata.append(`items[${i}][id]`, document?.id) : null;
                        // document?.attachment ? formdata.append(`items[${i}][attachment]`, document?.attachment) : null;
                    }
                    console.log('92=======>', formdata)

                    const { data } = await Axios.post(
                        Apis.updateChecklist,
                        formdata,
                        {
                            headers: getHeaders()
                        }

                    );
                    if (data?.success) {
                        resolve(data);
                        dispatch(GeneralAction.HideLoading());
                    } else {
                        dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))

                        // Alert.alert('Note', data?.message)
                        dispatch(GeneralAction.HideLoading());
                    }
                }
                catch (error) {
                    reject(error)
                    console.log(error.message)
                    dispatch(GeneralAction.HideLoading())
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

                    // alert('Network Error !')
                }
            })
        }
    };


    static deleteChecklistitem = id => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    let formdata = new FormData();
                    formdata.append('id', id);
                    const { data } = await Axios.post(
                        Apis.deleteChecklist,
                        formdata,
                        {
                            headers: getHeaders()
                        }
                    );
                    if (data?.success) {
                        resolve(data);
                        dispatch(GeneralAction.HideLoading());
                    } else {
                        dispatch(GeneralAction.HideLoading());
                    }
                } catch (error) {
                    reject(error);
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

                    // alert('Network Error');
                    console.log(error);
                    dispatch(GeneralAction.HideLoading());
                }
            });
        };
    };



    static deleteChecklist = id => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    let formdata = new FormData();
                    formdata.append('id', id);
                    const { data } = await Axios.post(
                        Apis.deleteChecklist,
                        formdata,
                        {
                            headers: getHeaders()
                        }
                    );
                    if (data?.success) {
                        resolve(data);
                        dispatch(GeneralAction.HideLoading());
                    } else {
                        dispatch(GeneralAction.HideLoading());
                    }
                } catch (error) {
                    reject(error);
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

                    // alert('Network Error');
                    console.log(error);
                    dispatch(GeneralAction.HideLoading());
                }
            });
        };
    };



}

export default LocationMiddleware;